import { AudioPlayerHandler } from "./audioPlayerHandler";
import { Logger, LogManager } from "../logger/logger";
import { PlayerException } from "../exceptions/playerException";

export interface AudioPlayer
{
    playURL(streamingUrl: string): void; 
    play(): void;
    stop(): void;
    setAudioPlayerHandler(audioPlayerHandler: AudioPlayerHandler): void;
    getAudio(): HTMLMediaElement;
}

export class AudioPlayerImpl implements AudioPlayer 
{
    // private static STREAMING_URL = "http://10.0.0.27:8120/MediaServer1.0.0.1/strm?src=";
    // private static STREAMING_URL: string;
    private logger: Logger = LogManager.getLogger(AudioPlayerImpl.name);
    private audio: HTMLMediaElement;
    private audioPlayerHandler: AudioPlayerHandler;
    //private seekBar: HTMLInputElement;

    constructor()
    {
        // AudioPlayerImpl.STREAMING_URL = streamingURL;
        this.audio = document.createElement('audio');
        this.audio.setAttribute("id", "audioplayer0312");

        this.onComplete = this.onComplete.bind(this);
        this.onError = this.onError.bind(this);
        // this.updateTheTime = this.updateTheTime.bind(this);
        // this.setSeekBar = this.setSeekBar.bind(this);

        // this.audio.addEventListener('timeupdate', this.updateTheTime, false);
        // this.audio.addEventListener('durationchange', this.setSeekBar, false);
        this.audio.addEventListener("ended", this.onComplete);
        this.audio.addEventListener("error", this.onError);
    }

    setAudioPlayerHandler(audioPlayerHandler: AudioPlayerHandler): void 
    {
       this.audioPlayerHandler = audioPlayerHandler;
    }

    getAudio(): HTMLMediaElement
    {
        return this.audio;
    }

    playURL(mediaUrl: string): void 
    {
        this.logger.log("play() invoked: URL: " + mediaUrl);

        if(mediaUrl !== null && mediaUrl !== "")
        {
           this.audio.src = mediaUrl;

        //    this.audioPlayerHandler.updateStartTime("00:00");
        //    this.audioPlayerHandler.updateEndTime(String(this.audio.duration));

           Promise.resolve(this.audio.play()).catch((e)=>
           {
               
           });
        }
        else
        {
           this.logger.error("Invalid Player StreamUrl received");
           
           throw new PlayerException("Invalid Player StreamUrl received");
        }
    }

    play(): void
    {
        Promise.resolve(this.audio.play()).catch((e)=>
           {
               
           });
    }

    stop(): void
    {
    //    this.logger.log("stop() invoked");
       
        this.audio.pause(); 
        // this.audio.currentTime = 0;
    }

     onComplete(): void
    {
        // this.logger.log("onComplete invoked()");

        // this.audioPlayerHandler.updateStartTime("00:00");

        this.audioPlayerHandler.onPlayComplete();
    }
    onError(): void
    {
        // this.logger.log("onError invoked()");  

        this.audioPlayerHandler.onPlayError();
    }  

    /* setSeekbar(seekBar: HTMLInputElement)
    {
        this.seekBar = seekBar;
    } */

    /* changeCurrentTime() 
    {
        this.audio.currentTime = +this.seekBar.value;
    } */

     /* setSeekBar() 
    {
        this.seekBar.min = "0";
        this.seekBar.max = String(this.audio.duration);
    } */

    /*  updateTheTime() 
    {
        this.audioPlayerHandler.updateEndTime(String(this.audio.duration));

        let sec = this.audio.currentTime;
        sec = sec % 3600;
        let min = Math.floor(sec / 60);
        sec = Math.floor(sec % 60);
        if(sec.toString().length < 2) 
        {
            sec = +("0" + sec);
        }
        if(min.toString().length < 2) 
        {
            min = +("0" + min);
        }
       this.audioPlayerHandler.updateStartTime(min + ":" + sec);

        this.seekBar.min = "0";
        this.seekBar.max = String(this.audio.duration);
        this.seekBar.value = String(this.audio.currentTime);
    } */
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/player/audioplayerImpl.ts